module.exports = __webpack_public_path__ + "img/suenio_warning.21319601.svg";